<template>
  <div class="newwarp boxsizing miniwarp gray80">
    <div class="auto">
      <page-title title="公众号" icon="fa-compass"></page-title>
    </div>
    <div class="m-t-15">
      <div class="summary auto" v-loading="summaryLoading">
        <el-row>
          <el-col :span="6" align="center">
            <div class="summary-box border-b border-b-color-1">
              <p class="font30 gray80 number">{{util.numberFormat(summary.menu_count) || 0}}</p>
              <span class="font12 gray99">菜单次数</span>
              <el-tooltip class="item" effect="dark" content="公众号接入平台至今，菜单点击次数累计。" placement="top">
                <i class="fa fa-question-circle-o grayce"></i>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="6" align="center">
            <div class="summary-box border-b border-b-color-2">
              <p class="font30 gray80 number">{{util.numberFormat(summary.menu_user) || 0}}</p>
              <span class="font12 gray99">菜单人数</span>
              <el-tooltip class="item" effect="dark" content="公众号接入平台至今，菜单点击人数（去重）累计。" placement="top">
                <i class="fa fa-question-circle-o grayce"></i>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="6" align="center">
            <div class="summary-box border-b border-b-color-3">
              <p class="font30 gray80 number">{{util.numberFormat(summary.scan_count) || 0}}</p>
              <span class="font12 gray99">扫码次数</span>
              <el-tooltip class="item" effect="dark" content="公众号接入平台至今，扫描二维码次数累计。" placement="top">
                <i class="fa fa-question-circle-o grayce"></i>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="6" align="center">
            <div class="summary-box border-b border-b-color-4">
              <p class="font30 gray80 number">{{util.numberFormat(summary.scan_user) || 0}}</p>
              <span class="font12 gray99">扫码人数</span>
              <el-tooltip class="item" effect="dark" content="公众号接入平台至今，扫描二维码人数（去重）累计。" placement="top">
                <i class="fa fa-question-circle-o grayce"></i>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="菜单 " tooltip="以近一个月为默认时间，可自行选择时间维度查看数据，最多可选取180天，统计时间段内用户点击公众号菜单的互动行为。<br/>
*菜单互动人数，所选时间段内，菜单点击人数累计。<br/>
*菜单互动次数，所选时间段内，菜单点击次数累计。<br/>
鼠标放在图表上，可查看菜单点击数据详情；<br/>
点击蓝色菜单名称，可进入查看该菜单点击详情。" v-loading="menuLoading">
            <div slot="bar">
              <dates-picker v-model="hDate" size="mini"></dates-picker>
              <!-- <el-input v-model="menuKeyword" placeholder="请输入菜单名称" clearable size="small" style="float:left;width:200px;margin-right:15px;"></el-input>
              <el-button type="primary" size="small" @click="menuSearch">搜索</el-button> -->
            </div>
            <div slot="content">
              <el-row>
                <el-col :span="6">
                  <echarts :data="menuchart" title="" height="320" :nohader="true"></echarts>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="17">
                  <el-table :data="menuTotalData" @sort-change="sortChangeMenuTable">
                    <el-table-column prop="name" label="菜单名称">
                      <template slot-scope="scope">
                        <a href="javascript:;" @click="getMenuDetails(scope.row)" class="alink">{{scope.row.name}}</a>
                      </template>
                    </el-table-column>
                    <el-table-column prop="uni" sortable label="互动人数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.uni)}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="total" sortable label="互动次数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.total)}}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="total_pre" sortable label="互动行为占比">
                      <template slot-scope="scope">{{scope.row.total_pre}}%</template>
                    </el-table-column>
                    <el-table-column prop="avg" sortable label="人均互动次数"></el-table-column> -->
                  </el-table>
                  <div class="pageBox" v-if="menuTableData.length > menuPageSize">
                    <el-pagination
                      layout="prev, pager, next"
                      :page-size="menuPageSize"
                      @current-change="menuTablePage"
                      :current-page.sync="menuPage"
                      :total="menuTableData.length"
                      align="right">
                    </el-pagination>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="扫码 " tooltip="以近一个月为默认时间，可自行选择时间维度查看数据，最多可选取180天，统计时间段内每天用户扫描二维码次数以及扫描二维码人数。" v-loading="typeMessageLoading">
            <div slot="bar">
              <dates-picker v-model="hDate2" size="mini"></dates-picker>
            </div>
            <div slot="content">
              <el-table :data="typeMessageTotal" @sort-change="sortChangeTypeMessage">
                <el-table-column prop="day" label="日期" width="420"></el-table-column>
                <el-table-column prop="count" sortable label="扫码次数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.count)}}
                  </template>
                </el-table-column>
                <el-table-column prop="user" sortable label="扫码人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.user)}}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox" v-if="typeMessage.length > pageSize">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  @current-change="typeMessageTablePage"
                  :current-page.sync="typeMessagePage"
                  :total="typeMessage.length"
                  align="right">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>

    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="关键词 " tooltip="以近一个月为默认时间，可自行选择时间维度查看数据，最多可选取180天，统计时间段内关键词触发次数及人数。" v-loading="keywordMessageLoading">
            <div slot="bar">
              <dates-picker v-model="hDate3" size="mini"></dates-picker>
            </div>
            <div slot="content">
              <el-table :data="keywordMessageTotal" @sort-change="sortChangeKeywordMessage">
                <el-table-column prop="name" label="关键词" width="420">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="getUserAttrDetail(scope.row)">{{scope.row.name}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="total" sortable label="次数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.total)}}
                  </template>
                </el-table-column>
                <el-table-column prop="uni" sortable label="人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.uni)}}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox" v-if="keywordMessage.length > pageSize">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  @current-change="keywordMessageTablePage"
                  :current-page.sync="keywordMessagePage"
                  :total="keywordMessage.length"
                  align="right">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <detail-dialog :title="row.name" :status="dialogStatus" :dialogVisible="dialogVisible" :chartData="dialogChart" :tableHead="tableHead" :tableData="tableData" @tableSortChange="tableSortChange" @visibleFn="visibleFn">
      <div slot="bar" style="text-align: right; padding: 15px 0;">
        <dates-picker v-model="dialogDate" size="mini" style="position: relative; top: 2px;"></dates-picker>
      </div>
    </detail-dialog>
    <detail-dialog :title="menuRow.name" :status="menuDialogStatus" :dialogVisible="menuDialogVisible" :chartData="menuDialogChart" :tableHead="tableHead" :tableData="menuDialogTableData" @tableSortChange="menuTableSortChange" @visibleFn="menuVisibleFn">
      <div slot="bar" style="text-align: right; padding: 15px 0;">
        <dates-picker v-model="menuDialogDate" size="mini" style="margin-right:15px;position: relative; top: 2px;"></dates-picker>
        <el-radio-group v-model="menuInterval" size="mini">
          <el-radio-button :label="item.value" v-for="(item, index) in dialogOptions" :key="index">{{item.label}}</el-radio-button>
        </el-radio-group>
      </div>
    </detail-dialog>
  </div>
</template>
<script>
import { Data as DataModel } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      loading: false,
      summaryLoading: false,
      summary: {
      },
      menuLoading: false,
      hDate: this.util.getDataPickerDefault(),
      pageSize: 10,
      menuRow: '',
      menuTableData: [],
      menuTableDataCopy: [],
      menuchart: {},
      menuPageSize: 5,
      menuPage: 1,
      menuTotalData: [],
      menuKeyword: '',
      menuDialogStatus: true,
      menuDialogVisible: false,
      menuDialogChart: {},
      menuDialogTableData: [],
      menuInterval: 'day',
      dialogOptions: [
        {
          value: 'day',
          label: '日'
        },
        {
          value: 'week',
          label: '周'
        },
        {
          value: 'month',
          label: '月'
        }
      ],
      menuDialogDate: this.util.getDataPickerDefault(),
      hDate2: this.util.getDataPickerDefault(),
      typeMessageLoading: false,
      typeMessage: [],
      typeMessageTotal: [],
      typeMessagePage: 1,
      hDate3: this.util.getDataPickerDefault(),
      keywordMessageLoading: false,
      keywordMessage: [],
      keywordMessageTotal: [],
      dialogDate: this.util.getDataPickerDefault(),
      dialogVisible: false,
      dialogStatus: true,
      dialogChart: {},
      row: '',
      tableHead: [
        {
          title: '日期',
          tag: 'name',
          sort: true
        },
        {
          title: '互动人数',
          tag: 'uni',
          sort: true,
          thousand: true
        },
        {
          title: '互动次数',
          tag: 'total',
          sort: true,
          thousand: true
        }
      ],
      tableData: []
    }
  },
  watch: {
    'hDate': function (val) {
      this.getMenuEventAggs()
    },
    'hDate2': function (val) {
      this.getMessageDayData()
    },
    'hDate3': function (val) {
      this.getMessageKeywordData()
    },
    'dialogDate': function (val) {
      if (this.dialogVisible) {
        this.getUserAttrDetail(this.row)
      }
    },
    'menuInterval': function (val) {
      if (this.menuDialogVisible) {
        this.getMenuDetails(this.menuRow)
      }
    },
    'menuDialogDate': function (val, oldval) {
      if (this.menuDialogVisible) {
        this.getMenuDetails(this.menuRow)
      }
    }
  },
  methods: {
    visibleFn (val) {
      this.dialogVisible = val
      this.dialogStatus = true
      this.isMessageOrEvent = false
    },
    tableSortChange (column) {
      var tableData = this.tableData
      this.util.arraySort(tableData, column['prop'], column['order'])
      this.tableData = tableData
    },
    async getUserAttrDetail (row, sort) {
      this.row = row
      if (!this.dialogVisible && String(this.dialogDate) !== String(this.hDate3)) {
        this.dialogDate = this.hDate3
      }
      this.dialogVisible = true
      this.dialogStatus = !this.dialogStatus
      let res = await DataModel.Behavior.getMessageKeywordDetail({
        keyword: row.name,
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1]
      })
      this.dialogChart = DataController.Behavior.mpBarAndLine(res['data'] || '')
      this.tableData = res['data'] || []
    },
    sortChangeKeywordMessage (column) {
      var keywordMessage = this.keywordMessage
      this.util.arraySort(keywordMessage, column['prop'], column['order'])
      this.keywordMessageTablePage(1)
      this.keywordMessagePage = 1
      this.keywordMessage = keywordMessage
    },
    keywordMessageTablePage (val) {
      var start = (val - 1) * this.pageSize
      var end = val * this.pageSize
      this.keywordMessagePage = val
      this.keywordMessageTotal = this.keywordMessage.slice(start, end)
    },
    async getMessageKeywordData () {
      this.keywordMessageLoading = true
      let res = await DataModel.Behavior.getMessageKeywordData({
        begin_time: this.hDate3[0],
        end_time: this.hDate3[1]
      })
      if (!res['err_code']) {
        this.keywordMessage = res.data
        this.keywordMessageTablePage(1)
      }
      this.keywordMessageLoading = false
    },
    async getMessageDayData () {
      this.typeMessageLoading = true
      let res = await DataModel.Behavior.getBehaviorMessageAggs({
        begin_time: this.hDate2[0],
        end_time: this.hDate2[1]
      })
      if (!res['err_code']) {
        this.typeMessage = res.data
        this.typeMessageTablePage(1)
      }
      this.typeMessageLoading = false
    },
    sortChangeTypeMessage (column) {
      var typeMessage = this.typeMessage
      this.util.arraySort(typeMessage, column['prop'], column['order'])
      this.typeMessageTablePage(1)
      this.typeMessagePage = 1
      this.typeMessage = typeMessage
    },
    typeMessageTablePage (val) {
      var start = (val - 1) * this.pageSize
      var end = val * this.pageSize
      this.typeMessagePage = val
      this.typeMessageTotal = this.typeMessage.slice(start, end)
    },
    async getOverviewSummary () {
      this.loading = true
      let res = await DataModel.Behavior.getBehaviorMpTotal()
      if (!res['err_code']) {
        this.summary = res['data']
      }
      this.loading = false
    },
    sortChangeMenuTable (column) {
      var menuTableData = this.menuTableData
      this.util.arraySort(menuTableData, column['prop'], column['order'])
      this.menuTablePage(1)
      this.menuPage = 1
      this.menuTableData = menuTableData
    },
    menuTablePage (val) {
      var start = (val - 1) * this.menuPageSize
      var end = val * this.menuPageSize
      this.menuPage = val
      this.menuTotalData = this.menuTableData.slice(start, end)
    },
    async getMenuEventAggs () {
      this.menuLoading = true
      let res = await DataModel.Behavior.getBehaviorMenuAggs({
        begin_time: this.hDate[0],
        end_time: this.hDate[1]
      })
      if (!res['err_code']) {
        this.menuTableData = res.data.table || []
        this.menuTableDataCopy = res.data.table || []
        this.menuTablePage(1)
        this.menuchart = DataController.Behavior.menuClickDistribution(res.data.chart || [], 'pv')
      }
      this.menuLoading = false
    },
    menuSearch () {
      if (this.menuKeyword !== '') {
        var tableData = []
        this.menuTableData.map(item => {
          if (item.name.indexOf(this.menuKeyword) > -1) {
            tableData.push(item)
          }
        })
        this.menuTableData = tableData
      } else {
        this.menuTableData = this.menuTableDataCopy
      }
      this.menuTablePage(1)
    },
    menuTableSortChange (column) {
      var menuDialogTableData = this.menuDialogTableData
      this.util.arraySort(menuDialogTableData, column['prop'], column['order'])
      this.menuDialogTableData = menuDialogTableData
    },
    menuVisibleFn (val) {
      this.menuDialogVisible = val
      this.menuDialogStatus = true
    },
    async getMenuDetails (row) {
      this.menuRow = row
      if (!this.menuDialogVisible && String(this.menuDialogDate) !== String(this.hDate)) {
        this.menuDialogDate = this.hDate
      }
      this.menuDialogVisible = true
      this.menuDialogStatus = !this.menuDialogStatus
      let res = await DataModel.Behavior.getBehaviorMenuDetailAggs({
        id: row.key,
        interval: this.menuInterval,
        begin_time: this.menuDialogDate[0],
        end_time: this.menuDialogDate[1]
      })
      this.menuDialogChart = DataController.Behavior.mpBarAndLine(res['data'] || '')
      this.menuDialogTableData = res['data'] || []
    }
  },
  created () {
    this.getOverviewSummary()
    this.getMenuEventAggs()
    this.getMessageDayData()
    this.getMessageKeywordData()
  },
  mounted () {
  }
}
</script>
<style scoped>
.summary {
  background: #fff;
  margin: 15px 0 0;
  border-radius: 5px;
}
.summary p.number {
  font-weight: 200;
}
.summary-box {
  line-height: 40px;
  padding: 40px 0;
  margin: 0 15px;
  box-sizing: border-box;
  margin-bottom: 2px;
}
.border-b-color-1 {
  border-bottom: 2px solid #31a4ff;
}
.border-b-color-2 {
  border-bottom: 2px solid #f18f1c;
}
.border-b-color-3 {
  border-bottom: 2px solid #5553ce;
}
.border-b-color-4 {
  border-bottom: 2px solid #ef1763;
}
.border-b-color-5 {
  border-bottom: 2px solid #6ab21b;
}
.border-b-color-6 {
  border-bottom: 2px solid #b959ff;
}
.qsgl-left label {
  /*display: block;*/
  margin: 0;
  margin-left: 20%;
  line-height: 48px;
}
</style>
